// extracted by css-extract-rspack-plugin
export default {"banner":"TbbSetupBudgetBanner-module__banner__D9qmE"};